import { Controller } from "@hotwired/stimulus"
import { sendMarketingEvent } from "../lib/marketing_events"

export default class extends Controller {
  static targets = ["step", "indicator", "previous", "next", "submit", "status"]
  static values = { newRecord: Boolean }

  connect() {
    this.index = 0
    this.showCurrentStep()
    this.trackStep()
  }

  next() {
    if (!this.currentStepIsValid()) return

    this.index = Math.min(this.index + 1, this.stepTargets.length - 1)
    this.showCurrentStep()
    this.trackStep()
    this.scrollToTop()
  }

  previous() {
    this.index = Math.max(this.index - 1, 0)
    this.showCurrentStep()
    this.scrollToTop()
  }

  showCurrentStep() {
    this.stepTargets.forEach((step, index) => {
      step.hidden = index !== this.index
    })

    this.indicatorTargets.forEach((indicator, index) => {
      const active = index === this.index
      const complete = index < this.index
      indicator.setAttribute("aria-current", active ? "step" : "false")
      indicator.classList.toggle("border-cyan-500", active)
      indicator.classList.toggle("bg-cyan-50", active)
      indicator.classList.toggle("text-cyan-800", active)
      indicator.classList.toggle("dark:bg-cyan-950", active)
      indicator.classList.toggle("dark:text-cyan-200", active)
      indicator.classList.toggle("border-emerald-300", complete)
      indicator.classList.toggle("bg-emerald-50", complete)
      indicator.classList.toggle("text-emerald-800", complete)
      indicator.classList.toggle("dark:bg-emerald-950", complete)
      indicator.classList.toggle("dark:text-emerald-200", complete)
    })

    const last = this.index === this.stepTargets.length - 1
    this.previousTarget.hidden = this.index === 0
    this.nextTarget.hidden = last
    this.submitTarget.hidden = !last
    this.statusTarget.textContent = `Step ${this.index + 1} of ${this.stepTargets.length}`
  }

  currentStepIsValid() {
    const fields = this.stepTargets[this.index].querySelectorAll("input, select, textarea")
    for (const field of fields) {
      if (!field.checkValidity()) {
        this.track("project_intake_validation_blocked")
        field.reportValidity()
        return false
      }
    }
    return true
  }

  scrollToTop() {
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  trackStep() {
    this.track("project_intake_step_viewed")
  }

  track(name) {
    if (!this.newRecordValue) return

    sendMarketingEvent(name, {
      step: this.stepTargets[this.index]?.dataset.intakeStep || `step_${this.index + 1}`
    })
  }
}
